class VHFeatureGallery extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.dialog = this.querySelector('dialog');
    this.items = [...this.querySelectorAll('[data-feature-open]')];
    if (!this.dialog || !this.items.length) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.photo = this.querySelector('[data-feature-image]');
    this.caption = this.querySelector('[data-feature-caption]');
    this.counter = this.querySelector('[data-feature-counter]');
    this.items.forEach((item, index) => item.addEventListener('click', () => this.open(index), { signal }));
    this.querySelector('[data-feature-close]').addEventListener('click', () => this.dialog.close(), { signal });
    this.querySelector('[data-feature-previous]').addEventListener('click', () => this.show(this.index - 1), { signal });
    this.querySelector('[data-feature-next]').addEventListener('click', () => this.show(this.index + 1), { signal });
    this.querySelectorAll('[data-feature-previous], [data-feature-next]').forEach(button => { button.hidden = this.items.length < 2; });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
    }, { signal });
    this.dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = this.previousOverflow;
      this.opener?.focus({ preventScroll: true });
    }, { signal });
    const stage = this.querySelector('[data-feature-stage]');
    stage.addEventListener('pointerdown', (event) => {
      this.touchStart = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY } : null;
    }, { signal });
    stage.addEventListener('pointerup', (event) => {
      if (!this.touchStart) return;
      const dx = event.clientX - this.touchStart.x;
      const dy = event.clientY - this.touchStart.y;
      this.touchStart = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
    }, { signal });
    stage.addEventListener('pointercancel', () => { this.touchStart = null; }, { signal });
  }
  show(index) {
    this.index = (index + this.items.length) % this.items.length;
    const item = this.items[this.index];
    this.photo.src = item.dataset.featureSrc;
    this.photo.alt = item.dataset.featureAlt || item.dataset.featureTitle || '';
    this.caption.textContent = item.dataset.featureTitle;
    this.counter.textContent = `${this.index + 1} / ${this.items.length}`;
  }
  open(index) {
    this.opener = this.items[index];
    this.show(index);
    this.previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    this.dialog.showModal();
  }
  disconnectedCallback() {
    if (this.dialog?.open) {
      document.documentElement.style.overflow = this.previousOverflow;
      this.dialog.close();
    }
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('vh-feature-gallery')) customElements.define('vh-feature-gallery', VHFeatureGallery);
